import { render } from "./DeleteReservation.vue?vue&type=template&id=b6ed94e4&scoped=true&ts=true"
import script from "./DeleteReservation.vue?vue&type=script&lang=ts"
export * from "./DeleteReservation.vue?vue&type=script&lang=ts"

import "./DeleteReservation.vue?vue&type=style&index=0&id=b6ed94e4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6ed94e4"]])

export default __exports__